<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          EMISSÃO DE PEDIDOS - FINALIZAR PEDIDO
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-tooltip top color="black" lazy v-if="promotion.id !== ''">
          <template v-slot:activator="{ on }">
            <v-chip class="ma-2" color="red" label text-color="white" v-on="on">
              <v-icon left color="yellow" small> mdi-star </v-icon>
              Promoção:
              {{ promotion.description.substring(0, 25).toUpperCase() }}
            </v-chip>
          </template>
          <span>{{ promotion.description }}</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-toolbar-title v-if="order.code">
          Pedido: {{ order.franchise_code }} - {{ order.code }}
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form">
        <v-container fluid>
          <alert
            :visible="!!error"
            dark
            type="error"
            :message="error"
            :clickClose="() => (error = '')"
          />
          <v-row>
            <v-col class="py-2">
              <label>Franqueado:</label><br />
              <label class="font-weight-bold">
                {{ order.franchise_code }} - {{ order.franchise_name }}
              </label>
            </v-col>
            <v-col class="py-2">
              <label>Fornecedor:</label><br />
              <label class="font-weight-bold">
                {{ order.provider_code }} - {{ order.provider_name }}
              </label>
            </v-col>
            <v-col class="py-2">
              <label>Emissão:</label><br />
              <label class="font-weight-bold">
                {{ getIssuanceDate(order.issuance_date) | dateFormatBr }}
              </label>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-2">
              <label>Frete/Transportadora:</label><br />
              <label class="font-weight-bold">
                <v-select
                  :items="shippings"
                  v-model="shipping"
                  hide-details
                  dense
                  outlined
                ></v-select>
              </label>
            </v-col>
            <v-col class="py-2">
              <label>Data Estimada de Faturamento:</label><br />
              <label class="font-weight-bold">
                {{ getEstimateDate(order.estimate_date) | dateFormatBr }}
              </label>
            </v-col>
            <v-col class="py-2">
              <label>Data Desejada de Faturamento:</label><br />
              <v-col md="6" class="pa-0">
                <v-text-field
                  v-mask="dateMask"
                  outlined
                  dense
                  hide-details
                  v-model="order.desired_date"
                  append-outer-icon="mdi-calendar"
                  @click:append-outer="handleClickCalendar()"
                  @blur="blurDesiredBillingDate()"
                ></v-text-field>
              </v-col>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-2">
              <label>Pagamento:</label><br />
              <label class="font-weight-bold">
                <v-select
                  :items="payment_conditions"
                  :item-text="(item) => `${item.name}`"
                  item-value="id"
                  v-model="payment_condition"
                  hide-details
                  dense
                  outlined
                  :disabled="disabledPaymentCondition"
                  @input="calculateParcels(true)"
                ></v-select>
              </label>
            </v-col>
            <v-col class="py-2">
              <label>Desconto:</label><br />
              <v-col md="4" class="pa-0">
                <v-text-field
                  label=""
                  hide-details
                  v-model="discount"
                  outlined
                  dense
                  suffix="%"
                  :disabled="disabledDiscount"
                  @input="calculateParcels(false)"
                ></v-text-field>
              </v-col>
            </v-col>
            <v-col class="py-2">
              <v-alert dense outlined type="warning" :value="alertShippingDate"
                >A data <strong>Desejada de Faturamento</strong> está menor que
                a <strong>Data Estimada pelo Fornecedor </strong>, por esse
                motivo o faturamento nesta data depende da aprovação do
                <strong>Fornecedor</strong>.
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <label class="text-h6">Situação do Pedido</label>
              <v-divider class="mb-1"></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" md="3" class="pt-0">
              <v-radio-group v-model="order.status" column class="mt-0">
                <label>Franqueado</label>
                <v-radio label="Em Manutenção" value="maintenance"></v-radio>
                <v-radio
                  label="Enviar para Franqueador"
                  value="sent_franchisor"
                ></v-radio>
                <label v-if="companySessionSelected.id === ''"
                  >Franqueador</label
                >
                <v-radio
                  v-if="companySessionSelected.id === ''"
                  label="Pedido em Análise"
                  value="review_franchisor"
                ></v-radio>
                <v-radio
                  v-if="companySessionSelected.id === ''"
                  label="Pedido Recusado"
                  value="refused_franchisor"
                ></v-radio>
                <v-radio
                  v-if="companySessionSelected.id === ''"
                  label="Pedido Validado"
                  value="validated_franchisor"
                ></v-radio>
                <label v-if="companySessionSelected.id === ''"
                  >Fornecedor</label
                >
                <v-radio
                  v-if="companySessionSelected.id === ''"
                  label="Pedido Confirmado"
                  value="confirmed_supplier"
                ></v-radio>
                <v-radio
                  v-if="companySessionSelected.id === ''"
                  label="Pedido Recusado"
                  value="refused_supplier"
                ></v-radio>
                <v-radio
                  v-if="companySessionSelected.id === ''"
                  label="Pedido Faturado"
                  value="invoiced_supplier"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-col cols="12" sm="7" md="8">
              <v-row>
                <v-col cols="12" sm="6" md="4" class="py-0 font-weight-bold"
                  >Produtos:</v-col
                >
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="py-0 text-right font-weight-bold"
                  >{{ order.products.length }}</v-col
                >
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4" class="py-0 font-weight-bold"
                  >Quantidade:</v-col
                >
                <v-col
                  cols="12"
                  md="3"
                  sm="6"
                  class="py-0 text-right font-weight-bold"
                  >{{ calculateQuantity() }}</v-col
                >
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4" class="py-0 font-weight-bold"
                  >Total dos produtos:</v-col
                >
                <v-col
                  cols="12"
                  md="3"
                  sm="6"
                  class="py-0 text-right font-weight-bold"
                  >{{ calculateTotalProducts() | currencyEuaToBr }}</v-col
                >
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4" class="py-0 font-weight-bold"
                  >Desconto:</v-col
                >
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="py-0 text-right font-weight-bold"
                  >{{ calculateDiscount() | currencyEuaToBr }}</v-col
                >
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4" class="py-0 font-weight-bold"
                  >Total do pedido:</v-col
                >
                <v-col
                  cols="12"
                  md="3"
                  sm="6"
                  class="py-0 text-right font-weight-bold"
                  >{{ calculateTotal() | currencyEuaToBr }}</v-col
                >
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="conditions.shipping.value !== ''"
                >
                  <strong
                    :class="
                      hitShippingCondition() ? 'green--text' : 'red--text'
                    "
                    >Frete CIF {{ formatShippingValue() }}</strong
                  >
                  <v-icon
                    right
                    :color="
                      hitShippingCondition() ? 'green darken-1' : 'red darken-1'
                    "
                    >{{
                      hitShippingCondition()
                        ? "mdi-checkbox-marked-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" v-else>
                  <strong class="grey--text text--darken-2"
                    >Frete CIF Não Disponível</strong
                  >
                  <v-icon right color="orange darken-2">mdi-alert</v-icon>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  sm="6"
                  class="text-right"
                  v-if="
                    conditions.minimum_order.value !== '' &&
                    conditions.minimum_order.value != 0
                  "
                >
                  <strong
                    :class="hitMinimumOrder() ? 'green--text' : 'red--text'"
                  >
                    Pedido Mínimo
                    {{ formatMinimumOrderValue() }}
                  </strong>
                  <v-icon
                    right
                    :color="
                      hitMinimumOrder() ? 'green darken-1' : 'red darken-1'
                    "
                    >{{
                      hitMinimumOrder()
                        ? "mdi-checkbox-marked-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="7">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="7" class="py-0">
                  <v-icon left color="green darken-1">mdi-cash</v-icon>
                  <label class="text-h6 font-weight-bold"
                    >Estimativa de Parcelamento</label
                  >
                </v-col>
                <v-col cols="12" xs="12" md="7" class="py-0">
                  <v-simple-table dense fixed-header height="170">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left fs-12 text-no-wrap">Parcela</th>
                          <th class="text-left fs-12 text-no-wrap">
                            Vencimento Estimado
                          </th>
                          <th class="text-right fs-12 text-no-wrap">
                            Valor Estimado
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="parcel in parcels" :key="parcel.parcel">
                          <td class="text-left">
                            {{ parcel.parcel | formatParcel }}
                          </td>
                          <td class="text-left">{{ parcel.date }}</td>
                          <td class="text-right">
                            {{ parcel.value | currencyEuaToBr }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-row>
                <v-col>
                  <v-icon left color="blue darken-3">mdi-cart-variant</v-icon>
                  <label class="text-h6">Carrinho</label>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-3"
                    dark
                    small
                    class="mt-3 float-right"
                    @click="addNewItem()"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Adicionar Novo Item
                  </v-btn>
                  <v-divider class="mb-2"></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table dense fixed-header height="250">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th colspan="6" class="text-left fs-12 text-no-wrap">
                            <label class="text-h6"
                              >{{ order.products.length }} Produtos no
                              Carrinho</label
                            >
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in order.products"
                          :key="`${item.reference}${item.color.id}${item.material.id}`"
                        >
                          <td class="text-right text-h6" width="50px">
                            {{ index + 1 }}
                          </td>
                          <td width="35%">
                            <div class="d-flex align-items-center">
                              <v-img
                                :src="getUrlPhoto(item.attr.photo)"
                                max-width="120"
                                :aspect-ratio="16 / 9"
                                class="my-2 image-clickable"
                                @click="
                                  onClickImage(getUrlPhoto(item.attr.photo))
                                "
                              />
                              <div class="ma-3 mt-5">
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Referência:</label
                                  >
                                  {{ order.provider_code }}{{ item.reference }}
                                </p>
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Material:</label
                                  >
                                  {{ item.material.name }}
                                </p>
                                <p class="mb-0">
                                  <label class="font-weight-bold">Cor:</label>
                                  {{ item.color.name }}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td width="25%">
                            <div class="d-flex align-items-center">
                              <div class="ma-3">
                                <div class="mb-0">
                                  <label class="font-weight-bold">Grade:</label>
                                  <table class="table-grid-cart">
                                    <thead>
                                      <tr>
                                        <th
                                          v-for="size in item.sizes"
                                          :key="`${size.id}${size.size}`"
                                          class="text-right"
                                        >
                                          {{ size.size }}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td
                                          v-for="size in item.sizes"
                                          :key="`${size.id}`"
                                          class="text-right"
                                        >
                                          {{ size.quantity }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td width="15%">
                            <div class="d-flex align-items-center">
                              <div class="ma-3">
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Qtde. Grade:</label
                                  >
                                  {{ getQuantitySum(item) }}
                                </p>
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Categoria:</label
                                  >
                                  {{ item.category.name }}
                                </p>
                                <p class="mb-0">
                                  <label class="font-weight-bold"
                                    >Subcategoria:</label
                                  >
                                  {{ item.subcategory.name }}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td width="15%">
                            <div class="d-flex align-items-center">
                              <div class="ma-3">
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Valor Original:</label
                                  >
                                  {{ getPriceByType(item) | currencyEuaToBr }}
                                </p>
                                <p class="mb-1">
                                  <label class="font-weight-bold"
                                    >Valor Unitário:</label
                                  >
                                  {{ getPriceDiscount(item) | currencyEuaToBr }}
                                </p>
                                <p class="mb-0">
                                  <label class="font-weight-bold">Total:</label>
                                  {{ getTotalPrice(item) | currencyEuaToBr }}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td width="10%" class="text-right">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="blue darken-3"
                                  class="mr-2"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="handleEditProduct(item)"
                                >
                                  mdi-pencil
                                </v-icon>
                              </template>
                              <span>Editar Produto</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="red darken-3"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="handleDeleteProduct(item)"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Remover Produto</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-icon left color="red darken-3">mdi-pencil</v-icon>
              <label class="text-h6">Notas</label>
              <v-divider class="mb-2"></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <label class="font-weight-bold"> Observações </label>
              <v-textarea
                outlined
                counter
                rows="4"
                no-resize
                row-height="30"
                name="print-observation"
                class="text-field-uppercase"
                v-model="order.observation"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <label class="font-weight-bold">
                Observações para o Fornecedor
              </label>
              <v-textarea
                outlined
                counter
                rows="4"
                no-resize
                row-height="30"
                name="provider-observation"
                class="text-field-uppercase"
                v-model="order.observation_provider"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" class="py-2">
              <v-btn
                color="blue darken-3"
                dark
                class="mt-3 float-right"
                @click="saveOrder()"
              >
                <v-icon left>mdi-check</v-icon>
                Gravar Pedido
              </v-btn>
              <!-- <v-btn
                color="red darken-3"
                dark
                outlined
                class="mt-3 float-right mr-4"
                @click="cancelOrder()"
              >
                <v-icon left>mdi-close</v-icon>
                Cancelar Lançamento do Pedido
              </v-btn> -->
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <ImageZoom
      :visible="dialogZoomPhoto"
      :closeDialog="closeDialogZoomPhoto"
      :photo="photoDialogZoom"
    />
    <v-dialog v-model="dialogDeleteProduct" persistent max-width="480px">
      <v-card>
        <v-card-title>Remover Produto</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          Deseja Realmente remover esse produto neste pedido?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="handleCancelDeleteProduct()"
          >
            Fechar
          </v-btn>
          <v-btn
            color="red darken-3"
            class="white--text"
            outlined
            @click="handleConfirmDeleteProduct()"
          >
            <v-icon left>mdi-delete</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditProduct" persistent max-width="1100px">
      <v-card>
        <v-card-title>Edição do Produto</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="12" md="4">
              <v-row>
                <v-col>
                  <v-text-field
                    class="text-field-uppercase border-color-field"
                    label="Referência:"
                    dense
                    readonly
                    outlined
                    :value="`${order.provider_code} ${editProduct.reference}`"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    class="text-field-uppercase border-color-field"
                    label="Nome:"
                    dense
                    readonly
                    outlined
                    :value="`${editProduct.product.name}`"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    class="text-field-uppercase border-color-field"
                    label="Categoria:"
                    dense
                    readonly
                    outlined
                    :value="`${editProduct.category.name}`"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    class="text-field-uppercase border-color-field"
                    label="Subcategoria:"
                    dense
                    readonly
                    outlined
                    :value="`${editProduct.subcategory.name}`"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    class="text-field-uppercase border-color-field"
                    label="Preço:"
                    dense
                    readonly
                    outlined
                    :value="`${currencyEuaToBr(editProduct.price)}`"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="materials"
                    :item-text="(item) => `${item.name}`"
                    item-value="id"
                    v-model="editProduct.material_id"
                    @change="handleChangeMaterial()"
                    label="Material:"
                    hide-details
                    clearable
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    :items="colors"
                    :item-text="(item) => `${item.name}`"
                    item-value="color"
                    v-model="editProduct.color_id"
                    @change="handleChangeColor()"
                    label="Cor:"
                    hide-details
                    clearable
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="8" class="py-2 d-flex justify-center">
              <v-img
                :src="getUrlPhoto(editProduct.attr.photo)"
                alt=""
                max-width="420"
                @click="onClickImage(getUrlPhoto(editProduct.attr.photo))"
                class="image-clickable"
                contain
                :aspect-ratio="16 / 9"
              ></v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" class="mb-0 py-2 pb-0">
              <label for="">Informe as Quantidades:</label>
            </v-col>
            <v-col
              cols="12"
              xs="12"
              class="py-2 pb-0"
              v-if="grid.type !== 'fechada'"
            >
              <div
                v-for="size in editProduct.sizes"
                :key="size.size"
                style="width: 50px; float: left; margin-right: 5px"
                class="py-0"
              >
                <label style="padding-left: 15px">{{ size.size }}</label>
                <v-text-field
                  v-model="size.quantity"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              xs="12"
              class="py-2 pb-0"
              v-if="grid.type === 'fechada'"
            >
              <div
                v-for="size in editProduct.sizes"
                :key="size.size"
                style="width: 80px; float: left; margin-right: 5px"
                class="py-0"
              >
                <label style="padding-left: 15px">{{ size.size }}</label>
                <v-select
                  :items="getOptionsGrid()"
                  v-model="size.quantity"
                  hide-details
                  dense
                  outlined
                ></v-select>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="handleCancelEditProduct()">
            Fechar
          </v-btn>
          <v-btn
            color="green darken-3"
            class="white--text"
            outlined
            @click="handleConfirmEditProduct()"
          >
            <v-icon left>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import { URL, URL_IMAGE } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as CompanyPromotionAPI from "@/api/requests/CompanyPromotionRequest";
import * as CompanyPaymentAPI from "@/api/requests/CompanyPaymentRequest";
import * as ShippingAPI from "@/api/requests/ShippingRequest";
import * as HTTP from "@/api/requests/base";

import { UF_REGIONS } from "@/api/constants";
import Alert from "@/components/Alert";
import ImageZoom from "@/components/ImageZoom";

import AwesomeMask from "awesome-mask";

export default {
  components: {
    Alert,
    ImageZoom,
  },
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    loading: false,
    error: "",
    reference: "",
    dialogZoomPhoto: false,
    photoDialogZoom: "",
    items: [],
    shipping: "",
    shippings: [
      {
        value: "",
        text: "Selecione",
      },
      {
        value: "cotacao",
        text: "A Definir (Fazer Cotação)",
      },
      {
        value: "cif",
        text: "CIF (Frete Pago pelo Fornecedor)",
      },
      // {
      //   divider: true,
      //   header: "FOB (Frete a Pagar)",
      // },
    ],
    payment_condition: "",
    payment_conditions: [],
    status: "maintenance",
    order: {
      company_promotion_id: null,
      products: [],
      created_at: "",
      desired_date: "",
      estimate_date: "",
      issuance_date: "",
    },
    dialogDeleteProduct: false,
    item_delete: {},
    modalDate: false,
    dateDialog: "",
    expected_billing_date: "",
    parcels: [],
    alertShippingDate: false,
    paymentsByProvider: [],
    discount: "0.00",
    dialogEditProduct: false,
    editProduct: {
      id: "",
      product: {
        name: "",
      },
      material_id: "",
      color_id: "",
      product_id: "",
      category: {},
      subcategory: {},
      attr: {},
      material: {},
    },
    materials: [],
    colors: [],
    attributes: [],
    sizes: [],
    promotion: {
      id: "",
      description: "",
    },
    disabledPaymentCondition: false,
    disabledDiscount: false,
    grid: {},
    conditions: {
      shipping: {
        value: "",
        type: "",
      },
      minimum_order: {
        value: "",
        type: "",
      },
    },
    companySessionSelected: {
      id: "",
    },
    daysEstimateDelivery: 60,
  }),
  computed: {
    fullReference() {
      if (this.product_order.reference == "") {
        return "";
      }
      return `${this.product_order.provider_code} ${this.product_order.reference}`;
    },
    fullProvider() {
      if (this.providerIsSelected()) {
        return `${this.provider.code} - ${this.provider.name}`;
      } else {
        return "";
      }
    },
    getPrice() {
      if (this.product_order.id == "") {
        return "";
      }
      let price =
        this.company.type == "fra"
          ? this.product_order.price_cif
          : this.product_order.price_mult;
      return this.currencyEuaToBr(price);
    },
  },
  // watch: {
  //   "provider.id"(value) {
  //     this.getShipping(value);
  //     // this.provider(value);
  //     console.log(value);
  //     console.log("DIEGO");
  //   },
  // },
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    dateTimeFormatBr: function (value) {
      if (!value) return;
      let [date, hours] = value.split(" ");
      date = date.split("-").reverse().join("/");
      return `${date} ${hours}`;
    },
    dateFormatBr: function (value) {
      if (!value) return;
      let [date] = value.split(" ");
      date = date.split("-").reverse().join("/");
      return `${date}`;
    },
    formatParcel: function (value) {
      return value.toString().padStart(2, "0");
    },
  },
  created() {
    // let dateNow = new Date();
    // let dateExpected = new Date(dateNow);
    // dateExpected.setDate(dateNow.getDate() + 30 * 3);
    // this.expected_billing_date = dateExpected.toLocaleDateString("pt-BR");

    let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
    if (session) {
      session = JSON.parse(session);
      if (
        session.company_selected !== "" &&
        session.company_selected !== undefined
      ) {
        this.companySessionSelected = session.company_selected;
      }
      this.initialize();
    } else {
      this.initialize();
    }

    // this.initialize();
  },
  methods: {
    async initialize() {
      if (!this.$route.params.order) {
        this.$router.push({ path: `/pedidos/cadastro/emissao-pedido` });
      } else {
        this.$vuetify.goTo(0, {
          duration: 300,
          offset: 0,
          easing: "easeInOutCubic",
        });
        this.getPaymentConditions();
        this.getDraft(this.$route.params.order);
      }
    },
    closeDialogZoomPhoto() {
      this.dialogZoomPhoto = false;
      this.photoDialogZoom = "";
    },
    getUrlPhoto(photo) {
      if (photo !== "") {
        return `${URL_IMAGE}${photo}`;
      } else {
        return "";
      }
    },
    goToBackList() {
      this.$router.push({
        name: "CreateInvoice",
        params: { id: this.$route.params.order },
      });
    },
    async getGrids(id) {
      this.loading = true;
      // this.sizes = [];
      this.grid = {};
      try {
        let response = await fetch(`${URL}product/product-sizes/${id}`);
        let data = await response.json();
        // this.sizes = data.sizes.map((item) => ({ size: item, quantity: 0 }));
        this.grid = data.grid;
        // console.log(this.grid);
      } catch (error) {
        // this.sizes = [];
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async getDraft(id) {
      this.loading = true;
      try {
        const response = await fetch(`${URL}order/draft/${id}`);
        let data = await response.json();
        this.order = data;
        // console.log(this.order);
        this.order.desired_date = this.dateFormatToBr(
          this.getDesiredDate(this.order.desired_date)
        );

        if (this.order.estimate_date === null) {
          this.order.estimate_date = this.getEstimateDate();
        }

        if (this.order.issuance_date === null) {
          this.order.issuance_date = this.getIssuanceDate();
        }

        if (
          this.order.status === "draft" ||
          this.order.status === "maintenance"
        ) {
          this.order.issuance_date = this.getIssuanceDate();
          this.order.estimate_date = this.getEstimateDate(
            this.order.estimate_date
          );
          this.blurDesiredBillingDate();
        }

        this.order.status =
          this.order.status === "draft" ? "maintenance" : this.order.status;
        if (this.order.observation !== null && this.order.observation !== "") {
          this.order.observation = JSON.parse(this.order.observation);
          this.order.observation = this.order.observation
            .map((item) => item.text)
            .join("<br />");
        }

        if (
          this.order.observation_provider !== null &&
          this.order.observation_provider !== ""
        ) {
          this.order.observation_provider = JSON.parse(
            this.order.observation_provider
          );
          this.order.observation_provider = this.order.observation_provider
            .map((item) => item.text)
            .join("<br />");
        }

        // console.log(this.order.observation);
        // this.order.observation = this.order.observation.map(
        //   (item) => item.text
        // );
        // this.order.observation_provider = "";
        // console.log(this.order.desired_date);
        this.getPaymentsByProvider(this.order.provider_id);
        this.getShipping(this.order.provider_id);
        this.getCompanyShippings(this.order.franchise_id);
        this.payment_condition = this.order.payment_condition_id;
        this.discount = this.order.discount;
        if (this.payment_condition !== "" && this.payment_condition !== null) {
          this.calculateParcels(false);
        }
        if (this.order.company_promotion_id !== null) {
          this.getPromotion(this.order.company_promotion_id);
        }
        // this.retrieveCart(data);
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível carregar o pedido em manutenção, verifique sua conexão e tente novamente";
        this.goToTop();
      } finally {
        this.loading = false;
      }
    },
    onClickImage(photo) {
      if (photo == "") return;
      this.photoDialogZoom = photo;
      this.dialogZoomPhoto = true;
    },
    getQuantitySum(item) {
      return item.sizes
        .map((prod) =>
          isNaN(parseInt(prod.quantity)) ? 0 : parseInt(prod.quantity)
        )
        .reduce((prev, curr) => prev + curr, 0);
    },
    getPriceByType(item) {
      return item.price;
    },
    getPriceDiscount(item) {
      return item.price - item.price * (parseFloat(this.discount) / 100);
    },
    getTotalPrice(item) {
      let price = this.getPriceDiscount(item);
      let quantity = this.getQuantitySum(item);
      return (price * quantity).toFixed(2);
    },
    async handleEditProduct(item) {
      this.dialogEditProduct = true;
      this.editProduct = JSON.parse(JSON.stringify(item));
      this.getMaterials(this.editProduct.product_id);
      await this.getGrids(item.grid_id);
      // console.log(item);
    },
    handleDeleteProduct(item) {
      this.item_delete = { ...item };
      this.dialogDeleteProduct = true;
    },
    async handleConfirmDeleteProduct() {
      console.log(this.item_delete);
      try {
        const myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(
          `${URL}order/${this.order.id}/product/${this.item_delete.id}`,
          {
            method: "DELETE",
            headers: myHeaders,
          }
        );
        if (res.ok) {
          this.getProductsOrder(this.order.id);
          alert("Produto deletado com sucesso");
        }
      } catch (error) {
        alert("Problema ao deletar o produto, entre em contato com suporte");
      } finally {
        this.dialogDeleteProduct = false;
      }
    },
    async saveOrderDraft(data) {
      // console.log(this.order);
      if (data.id !== "") {
        await this.putSaveOrderDraft(data.id, data);
      } else {
        this.error =
          "Atenção: Não foi possível salvar os dados desse pedido, tente novamente mais tarde";
        this.goToTop();
      }
    },
    async putSaveOrderDraft(id, data) {
      this.loading = true;
      const body = data;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        const response = await fetch(`${URL}order/${id}`, {
          method: "PUT",
          headers: myHeaders,
          body: JSON.stringify(body),
        });
        await response.json();
        alert("Pedido Salvo com Sucesso");
        this.$router.push({
          name: "EditInvoice",
        });
        // console.log(data);
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível atualizar o pedido, tente novamente mais tarde";
        this.goToTop();
      } finally {
        this.loading = false;
      }
    },
    async deleteOrderDraft(id) {
      this.loading = true;
      try {
        const response = await fetch(`${URL}order/${id}`, {
          method: "DELETE",
        });
        await response.json();
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível remover o pedido, tente novamente mais tarde";
        this.goToTop();
      } finally {
        this.loading = false;
      }
    },
    handleCancelDeleteProduct() {
      this.item_delete = {};
      this.dialogDeleteProduct = false;
    },
    saveOrder() {
      if (
        !this.hitMinimumOrder() &&
        this.order.status !== "draft" &&
        this.order.status !== "maintenance"
      ) {
        this.error =
          "Não é possível mudar a Situação do Pedido porque não atingiu o pedido mínimo";
        this.goToTop();
        return;
      }

      let data = { ...this.order };

      if (data.observation !== null) {
        data.observation = data.observation.toUpperCase();
      }
      if (data.observation_provider !== null) {
        data.observation_provider = data.observation_provider.toUpperCase();
      }
      data.shipping_method = "fob";
      data.payment_condition_id = this.payment_condition;
      data.discount = this.discount;
      data.items = data.products;

      if (data.issuance_date === null) {
        data.issuance_date = this.getIssuanceDate();
      } else {
        data.issuance_date = data.issuance_date.indexOf("/")
          ? this.dateFormatToEua(data.issuance_date)
          : data.issuance_date;
      }

      if (data.estimate_date === null) {
        data.estimate_date = this.getEstimateDate();
      } else {
        data.estimate_date = data.estimate_date.indexOf("/")
          ? this.dateFormatToEua(data.estimate_date)
          : data.estimate_date;
      }

      if (data.desired_date === null) {
        data.desired_date = this.getDesiredDate();
      } else {
        data.desired_date = data.desired_date.indexOf("/")
          ? this.dateFormatToEua(data.desired_date)
          : data.desired_date;
      }

      // console.log(data);
      data.parcels = this.parcels;

      if (this.shipping === "cif" || this.shipping === "cotacao") {
        data.shipping_method = this.shipping;
        data.shipping_company_id = null;
      } else {
        data.shipping_company_id = this.shipping;
      }
      this.saveOrderDraft(data);
    },
    cancelOrder() {
      alert("A decidir");
      return false;
    },
    handleClickCalendar() {
      let date = this.order.desired_date;
      this.dateDialog = this.dateFormatToEua(date);
      this.modalDate = true;
    },
    handlePickerDate() {
      this.order.desired_date = this.dateFormatToBr(this.dateDialog);
      this.dateDialog = "";
      this.modalDate = false;
      this.blurDesiredBillingDate();
    },
    dateFormatToBr(date) {
      if (date == "") return "";
      return date.split("-").reverse().join("/");
    },
    dateFormatToEua(date) {
      if (date == "") return "";
      return date.split("/").reverse().join("-");
    },
    // async getShippings() {
    //   this.loading = true;
    //   this.shippings = [];
    //   try {
    //     let data = await ShippingAPI.getAll();
    //     data = [
    //       ...data,
    //       {
    //         id: "cif",
    //         name: "CIF",
    //       },
    //     ];
    //     this.shippings = data.sort((a, b) => (a.name > b.name ? 1 : -1));
    //   } catch (error) {
    //     console.log(error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    async getPaymentConditions() {
      this.loading = true;
      this.payment_conditions = [];
      try {
        let res = await fetch(`${URL}payment-condition`);
        let data = await res.json();
        this.payment_conditions = data.sort((a, b) =>
          a.name > b.name ? 1 : -1
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async calculateParcels(getDiscountDB) {
      this.parcels = [];
      if (getDiscountDB && this.promotion.id === "") {
        let res = await this.getDiscount(
          this.order.provider_id,
          this.order.franchise_id,
          this.payment_condition
        );
        this.discount = res;
      }
      let total = this.calculateTotal();

      if (this.payment_condition === "") {
        return false;
      }
      if (this.order.desired_date === "") {
        return false;
      }
      let payment = this.payment_conditions.find(
        (item) => item.id === this.payment_condition
      );

      if (typeof payment === "undefined") {
        return false;
      }
      let [day, month, year] = this.order.desired_date.split("/");
      let dateExpected = new Date(year, month - 1, day);

      let value = (parseFloat(total) / payment.terms.length).toFixed(2);

      let dates = payment.terms.map((term, index) => {
        let dateCalculate = new Date(year, month - 1, day);
        dateCalculate.setDate(dateExpected.getDate() + term.days);
        return {
          parcel: ++index,
          value: value,
          date: dateCalculate.toLocaleDateString("pt-BR"),
        };
      });
      this.parcels = dates;
    },
    blurDesiredBillingDate() {
      if (this.order.desired_date === "" || null) {
        this.order.desired_date = this.dateFormatToBr(this.getDesiredDate());
      }
      this.calculateParcels(false);
      const getTimestamp = (date) => {
        let [year, month, day] = date.split("-");
        return new Date(year, month - 1, day).getTime();
      };

      if (this.order.estimate_date === null) {
        this.order.estimate_date = this.getEstimateDate();
      }

      const dateEstimate = this.order.estimate_date.indexOf("/")
        ? this.dateFormatToEua(this.order.estimate_date)
        : this.order.estimate_date;

      const dateDesired = this.order.desired_date.indexOf("/")
        ? this.dateFormatToEua(this.order.desired_date)
        : this.order.desired_date;

      this.alertShippingDate =
        getTimestamp(dateEstimate) > getTimestamp(dateDesired);
    },
    addNewItem() {
      this.$router.push({
        name: "CreateInvoice",
        params: { id: this.$route.params.order },
      });
    },
    async getPaymentsByProvider(id) {
      this.loading = true;
      this.paymentsByProvider = [];
      try {
        let data = await CompanyPaymentAPI.getAll(`?company_id=${id}`);
        this.paymentsByProvider = data;

        if (this.companySessionSelected.id !== "") {
          this.payment_conditions = this.paymentsByProvider.map(
            (item) => item.payment
          );
          if (this.promotion.id !== "") {
            this.setPaymentPromotion();
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getDiscount(provider_id, company_id, payment_id) {
      const body = {
        company_id,
        provider_id,
        payment_id,
      };
      try {
        let data = await CompanyPaymentAPI.getAllDiscount(body);
        // console.log(data);
        return data.discount;
      } catch (error) {
        return "0.00";
      } finally {
        this.loading = false;
      }
    },
    calculateQuantity() {
      if (this.order.products.length == 0) {
        return 0;
      }
      let sumQuantity = (prev, curr) => parseInt(prev) + parseInt(curr);

      const quantity = this.order.products
        .map((prod) => this.getQuantitySum(prod))
        .reduce(sumQuantity, 0);
      // console.log(quantity);
      return quantity;
    },
    calculateTotalProducts() {
      return this.order.products
        .map((item) => item.price * this.getQuantitySum(item))
        .reduce((prev, curr) => prev + curr, 0);
    },
    calculateDiscount() {
      let valueDiscount =
        this.calculateTotalProducts() * parseFloat(this.discount / 100);
      return valueDiscount;
    },
    calculateTotal() {
      let discount = this.calculateDiscount();
      return this.calculateTotalProducts() - discount;
    },
    handleCancelEditProduct() {
      this.dialogEditProduct = false;
      this.editProduct = JSON.parse(
        JSON.stringify({
          id: "",
          product: {
            name: "",
          },
          category: {},
          subcategory: {},
          attr: {},
          material: {},
          material_id: "",
          color_id: "",
          product_id: "",
        })
      );
    },
    async handleConfirmEditProduct() {
      console.log(this.editProduct);

      const myHeaders = new Headers({
        "Content-Type": "application/json",
      });

      const data = {
        id: this.editProduct.id,
        price: this.editProduct.price,
        material_id: this.editProduct.material_id,
        color_id: this.editProduct.color_id,
        sizes: this.editProduct.sizes,
      };

      try {
        let res = await fetch(
          `${URL}order/${this.editProduct.order_id}/product/${this.editProduct.id}`,
          {
            method: "PUT",
            headers: myHeaders,
            body: JSON.stringify(data),
          }
        );
        let response = await res.json();
        if (response.status === "ok") {
          this.getProductsOrder(this.order.id);
          alert(response.message);
          this.dialogEditProduct = false;
        } else {
          alert(response.message);
        }
      } catch (error) {
        alert("Problema ao salvar o produto, entre em contato com o suporte");
        console.log(error);
      }
    },
    async getProductsOrder(id) {
      try {
        let res = await fetch(`${URL}order/${id}/product`);
        let response = await res.json();
        this.order.products = response;
        this.order.products.sort((a, b) =>
          a.reference < b.reference ? -1 : 1
        );
        this.calculateParcels(false);
        this.changeCifShipping();
      } catch (error) {
        alert("Problema ao buscar os produtos, entre em contato com o suporte");
      }
    },
    changeCifShipping() {
      let index = this.shippings.findIndex((item) => item.value === "cif");
      let copyShipping = { ...this.shippings[index] };
      if (this.hitShippingCondition()) {
        this.shipping = "cif";
        copyShipping.disabled = false;
      } else {
        if (this.shipping == "cif") {
          this.shipping = "";
        }
        copyShipping.disabled = true;
      }
      this.shippings.splice(index, 1, copyShipping);
    },
    currencyEuaToBr(value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    async getMaterials(id) {
      this.loading = true;
      this.attributes = [];
      this.materials = [];
      try {
        let response = await fetch(`${URL}product/product-attr/${id}`);
        let data = await response.json();
        this.attributes = data;

        this.materials = data.map((item) => ({
          id: item.material_id,
          name: item.material_name,
        }));
        this.materials = [
          ...new Map(this.materials.map((item) => [item["id"], item])).values(),
        ];
        this.handleChangeMaterial();
      } catch (error) {
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    handleChangeMaterial() {
      // this.material_error = false;
      // console.log(this.attributes);
      // console.log(this.editProduct.material_id);

      this.colors = this.attributes.filter(
        (item) => item.material_id == this.editProduct.material_id
      );
      this.colors = this.colors.map((item) => ({
        color: item.color_id,
        id: item.id,
        name: item.color_name,
        photo: item.photo,
      }));
      // console.log(this.editProduct.color_id);
      // console.log(this.colors);
      // console.log(this.colors);
    },
    handleChangeColor() {
      let attr = this.attributes.find(
        (item) =>
          item.material_id == this.editProduct.material_id &&
          item.color_id == this.editProduct.color_id
      );
      this.editProduct.attr = { ...attr };
    },
    async getPromotion(id) {
      this.loading = true;
      try {
        let response = await CompanyPromotionAPI.getById(id);
        this.promotion = response.promotion;
        this.setPaymentPromotion();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    setPaymentPromotion() {
      if (this.promotion.payment !== null) {
        this.payment_conditions = [];
        // console.log(this.promotion.payment);
        this.payment_conditions.push(this.promotion.payment);
        this.payment_condition = this.promotion.payment.id;
        this.disabledPaymentCondition = true;
      }
      this.disabledDiscount = true;
      this.discount = this.promotion.discount;
      this.calculateParcels(false);
    },
    getOptionsGrid() {
      let data = this.grid.closed_grid.split(";").map((item) => parseInt(item));
      data.unshift(0);
      return data;
    },
    onFocusSize(size, index) {
      if (parseInt(size.quantity) == 0) {
        this.sizes[index].quantity = "";
      }
    },
    onBlurSize(size, index) {
      if (size.quantity == "") {
        this.sizes[index].quantity = 0;
      }
    },
    async getShipping(id) {
      // this.loading = true;
      try {
        let response = await ShippingAPI.getById(id);
        if (Object.keys(response).length === 0) {
          let company = await CompanyAPI.getById(id);
          this.conditions = {
            minimum_order: {
              type:
                company.type_minimum_order == null
                  ? ""
                  : company.type_minimum_order,
              value: company.minimum_order,
            },
            shipping: {
              type: "",
              value: "",
            },
          };
          this.shippings = this.shippings.filter(
            (item) => item.value !== "cif"
          );
        } else {
          this.conditions = {
            minimum_order: {
              value: response.company.minimum_order,
              type:
                response.company.type_minimum_order == null
                  ? ""
                  : response.company.type_minimum_order,
            },
            shipping: this.getShippingRules(response),
          };
        }
        // console.log(JSON.stringify(this.conditions));
      } catch (error) {
        console.log(error);
      }
    },
    getShippingRules(response) {
      let rule = {
        value: "",
        type: response.type,
      };
      let notEmpty = (value) => value !== null && value !== "";
      let state = this.order.franchise.delivery_state;

      if (notEmpty(state)) {
        if (response.states.length > 0 && rule.value === "") {
          let res = response.states.find((item) => item.name === state);
          if (res) {
            rule.value = res.minimum_order;
          }
        }

        if (response.regions.length > 0 && rule.value === "") {
          let detailState = UF_REGIONS.find((item) => item.value === state);
          let res = response.regions.find(
            (item) => item.name === detailState.region
          );
          if (res) {
            rule.value = res.minimum_order;
          }
        }
      }

      if (rule.value === "") {
        rule.value = response.minimum_order;
      }
      return rule;
    },
    hitMinimumOrder() {
      if (this.conditions.minimum_order.type === "pair") {
        return (
          parseInt(this.conditions.minimum_order.value) <=
          this.calculateQuantity()
        );
      }
      return (
        parseFloat(this.conditions.minimum_order.value) <=
        parseFloat(this.calculateTotal())
      );
    },
    formatMinimumOrderValue() {
      if (this.conditions.minimum_order.type === "pair") {
        return `${parseInt(this.conditions.minimum_order.value)} Itens`;
      }
      return this.currencyEuaToBr(
        parseFloat(this.conditions.minimum_order.value)
      );
    },
    hitShippingCondition() {
      let res = false;
      if (this.conditions.shipping.type === "pair") {
        res =
          parseInt(this.conditions.shipping.value) <= this.calculateQuantity();
      } else {
        res =
          parseFloat(this.conditions.shipping.value) <=
          parseFloat(this.calculateTotal());
      }
      // if (res) {
      //   this.shipping = "cif";
      // } else {
      //   this.shipping = "";
      // }
      return res;
    },
    formatShippingValue() {
      if (this.conditions.shipping.type === "pair") {
        return `${parseInt(this.conditions.shipping.value)} Itens`;
      }
      return this.currencyEuaToBr(parseFloat(this.conditions.shipping.value));
    },
    async getCompanyShippings(id) {
      // this.shippi = [];
      try {
        let res = await CompanyAPI.getAllShipping(id);
        let data = res;
        if (res.length > 0) {
          res = res.filter((item) => item.shipping !== null);

          this.shippings.push({
            divider: true,
            header: "FOB (Frete a Pagar)",
          });

          res
            .map((item) => ({
              value: item.shipping.id,
              text: item.shipping.name,
            }))
            .sort((a, b) => (a.text > b.text ? 1 : -1))
            .map((item) => this.shippings.push(item));

          this.shippings.map((item) => ({ ...item, disabled: false }));
        }

        // console.log(data);
        if (
          this.order.shipping_method === "fob" &&
          this.order.shipping_company_id !== null
        ) {
          this.shipping = this.order.shipping_company_id;
        } else {
          let favorite = data.find((item) => item.favorite == 1);
          console.log(favorite);
          if (favorite) {
            if (!this.hitShippingCondition()) {
              this.shipping = favorite.shipping_company_id;
            }
          }
        }

        this.changeCifShipping();
      } catch (error) {
        console.log(error);
      }
    },
    getEstimateDate(date) {
      console.log(date);
      if (date == null || (date == "" && this.order.id !== "")) {
        let now = new Date();
        now.setDate(now.getDate() + this.daysEstimateDelivery);
        return this.formatDate(now);
      }
      return date;
    },
    getDesiredDate(date) {
      if (date == null || date == "") {
        let now = new Date();
        now.setDate(now.getDate() + this.daysEstimateDelivery);
        return this.formatDate(now);
      }
      return date;
    },
    getIssuanceDate(date) {
      if (
        date == null ||
        date == "" ||
        this.order.status === "draft" ||
        this.order.status === "maintenance"
      ) {
        return this.formatDate();
      }
      return date;
    },
    goToTop() {
      this.$vuetify.goTo(0, {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      });
    },
    formatDate(date = new Date()) {
      const year = date.toLocaleString("default", { year: "numeric" });
      const month = date.toLocaleString("default", {
        month: "2-digit",
      });
      const day = date.toLocaleString("default", { day: "2-digit" });

      return [year, month, day].join("-");
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}

.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}

.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}

.image-clickable {
  cursor: pointer;
}

.cart-editing {
  background-color: #f9eec4;
}

.v-text-field--outlined.border-color-field >>> fieldset {
  border-color: #666;
}

.table-grid-cart {
  border-collapse: collapse;
}

.table-grid-cart > thead > tr > th,
.table-grid-cart > tbody > tr > td {
  padding: 6px;
  border: 1px solid black;
}

.table-grid-cart > tbody > tr > td {
  background-color: white !important;
}
</style>
